<app-product-breadcrumb [title]="'Checkout'" [breadcrumb]="'Checkout'"></app-product-breadcrumb>

<!-- section start -->
<section class="p-0" *ngIf="errore && carricamentoDati">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="error-section">
                    <h1>404</h1>
                    <h2>page not found</h2>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- voucher visit section start -->
<section class="section-b-space" *ngIf="!errore">
    <div class="container">
        <div class="vv-wrap">
            <div class="vv-icon"><i class="fa fa-gift" aria-hidden="true" style="color: #b8ab69;"></i></div>
            <h3 class="title-brown text-center"
                *ngIf="!completeVisitForm.get('VisitTimeInit')?.value && !completeVisitForm.get('VisitDateInit')?.value">
                {{"Ti è stata regalata una" | translate}} <strong>{{"visita guidata" | translate}}</strong>
                {{"presso il" | translate}} <strong>Caseificio Sociale di Soragna!</strong>
            </h3>
            <h3 class="title-brown text-center"
                *ngIf="completeVisitForm.get('VisitTimeInit')?.value || completeVisitForm.get('VisitDateInit')?.value">
                {{"Grazie! La prenotazione per la visita guidata presso il " | translate}}<strong>Caseificio Sociale
                    di Soragna</strong>{{" è stata confermata. Di seguito il dettaglio: " | translate}}
            </h3>

            <div class="ornament pb-4"></div>

            <aside class="visit-ticket-stub">
                <span class="stub-eyebrow">{{ "shoponline.PaginaVisitSuccess.dettagli" | translate }}</span>
                <h3>{{ "Il tuo regalo" | translate }}</h3>
                <dl class="stub-details">
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.numPersone" | translate }}</dt>
                        <dd>{{completeVisitForm.get('Nperson')?.value}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.numBambini" | translate }}</dt>
                        <dd>{{completeVisitForm.get('Nchild')?.value}}</dd>
                    </div>
                    <div *ngIf="completeVisitForm.get('NchildUnder6')?.value && completeVisitForm.get('NchildUnder6')?.value != 0">
                        <dt>{{ "shoponline.PaginaVisitSuccess.numBambiniSotto6" | translate }}</dt>
                        <dd>{{completeVisitForm.get('NchildUnder6')?.value}}</dd>
                    </div>
                    <div *ngIf="completeVisitForm.get('VisitDateInit')?.value">
                        <dt>{{ "shoponline.PaginaVisitSuccess.data" | translate }}</dt>
                        <dd>{{completeVisitForm.get('VisitDateInit')?.value | date: "dd-MM-yyyy"}}</dd>
                    </div>
                    <div *ngIf="completeVisitForm.get('VisitTimeInit')?.value">
                        <dt>{{ "shoponline.PaginaVisitSuccess.ora" | translate }}</dt>
                        <dd>{{completeVisitForm.get('VisitTimeInit')?.value}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.lingua" | translate }}</dt>
                        <dd>{{completeVisitForm.get('Language')?.value}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.degustazione" | translate }}</dt>
                        <dd>
                            <span
                                *ngIf="completeVisitForm.get('Tasting')?.value == true || completeVisitForm.get('Tasting2')?.value == true || completeVisitForm.get('Tasting3')?.value == true">
                                {{"Sì" | translate}}
                                <span *ngIf="completeVisitForm.get('Tasting2')?.value == true"> {{"(con anolini)" |
                                    translate}}</span>
                                <span *ngIf="completeVisitForm.get('Tasting3')?.value == true"> (con anolini e panino
                                    con culatello)</span>
                            </span>
                            <span
                                *ngIf="completeVisitForm.get('Tasting')?.value == false && completeVisitForm.get('Tasting2')?.value == false && completeVisitForm.get('Tasting3')?.value == false">
                                {{"No" | translate}}</span>
                        </dd>
                    </div>
                </dl>
            </aside>

            <div class="vv-pick-panel"
                *ngIf="!completeVisitForm.get('VisitTimeInit')?.value && !completeVisitForm.get('VisitDateInit')?.value">
                <p class="vv-pick-title">{{ "Scegli data e orario per completare la prenotazione" | translate }}</p>
                <form [formGroup]="completeVisitForm" (ngSubmit)="salvaVisita()">
                    <div class="vv-row">
                        <div class="visit-field visit-date-field">
                            <span class="visit-field-label">{{ 'visite.form.Data' | translate }}*</span>
                            <input type="text" class="visit-date-display" readonly
                                placeholder="{{ 'visite.form.Data' | translate }}" [(ngModel)]="dateModel"
                                [ngModelOptions]="{standalone: true}" ngbDatepicker
                                #voucherDatepicker="ngbDatepicker" [minDate]="minDate"
                                [markDisabled]="isDateDisabled" (dateSelect)="onDateSelect($event)"
                                (click)="voucherDatepicker.toggle()"
                                [ngClass]="{'is-invalid': submitted && form.VisitDate.errors}" />
                            <span class="visit-chevron">▾</span>
                            <div *ngIf="submitted && form.VisitDate.errors" class="invalid-feedback d-block">
                                <span *ngIf="form.VisitDate.errors.required">{{ 'visite.form.Obbligatorio' |
                                    translate }}</span>
                            </div>
                        </div>
                        <div class="visit-field">
                            <span class="visit-field-label">{{'visite.form.Orario' | translate }}*</span>
                            <div class="visit-time-pills">
                                <button type="button" disabled *ngIf="!hasTimeOptions">{{ timeOptions[0]?.ora
                                    | translate }}</button>
                                <ng-container *ngFor="let item of timeOptions">
                                    <button type="button" *ngIf="item.id !== ''"
                                        [class.active]="completeVisitForm.get('VisitTimeID')?.value === item.id"
                                        (click)="selectVisitTime(item)">{{ item.ora }}</button>
                                </ng-container>
                            </div>
                            <div *ngIf="submitted && (form.VisitTime.errors || (completeVisitForm.get('VisitTime')?.value == ''))"
                                class="invalid-feedback d-block">
                                <span>{{ 'visite.form.Obbligatorio' | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button type="submit" class="btn btn-solid">{{ "Salva" | translate }}</button>
                    </div>
                </form>
            </div>

            <div class="product-order success-text mt-4">
                <p class="text"> {{ "shoponline.PaginaVisitSuccess.PuoiContattarciVia" | translate }} &nbsp;<b
                        class="gold-text">
                        &#115;&#097;&#108;&#101;&#115;&#064;&#099;&#097;&#115;&#101;&#105;&#102;&#105;&#099;&#105;&#111;&#045;&#115;&#111;&#114;&#097;&#103;&#110;&#097;&#046;&#105;&#116;
                    </b><br> {{ "shoponline.PaginaCheckoutSuccess.PuoiChiamarci" | translate }}
                    <a href="tel:0524 599073">
                        <span class="gold-text">{{ "info-caseificio.telefono" | translate }}</span>
                    </a> {{ "shoponline.PaginaVisitSuccess.perQualsiasiEsigenza" | translate }}.
                </p>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->
